import { COLLECTIONS } from "constants/action-types";

export interface IRollupObjectRequest {
    merchant_id: string;
    rollup_snapshot_id: string;
    collection_id: string;
    object_id: string;
    revision: number;
}

export const fetchRollupObject = (payload: IRollupObjectRequest) => ({
    payload,
    type: COLLECTIONS.COLLECTION.ROLLUP_OBJECT.FETCH.START,
});
